<template>
  <div>
    <div class="d-inline-flex align-items-center">
      <h4>Model</h4>
      <!-- <div class="ml-4">
        <div class="row form-group align-items-center">
          <div class="col-sm-12">
            <select
              placeholder="Character Selector"
              class="custom-select"
              v-model="mainCharacterIndex"
              @change="changeModelInspector"
            >
              <option>Character Selector</option>
              <option
                v-for="(item, key) in charData"
                :key="key"
                :value="key"
              >
                {{ ( parseInt(key) + 1 )+ '. ' +item.name }}
              </option>
            </select>
          </div>
        </div>
      </div> -->
    </div>
    <div class="row">
      <div class="col-6">
        <div class="fields-wrapper">
          <div class="row form-group align-items-center">
            <label for="charname" class="col-sm-4 col-form-label">
              Model Selector
            </label>
            <div class="col-sm-8">
              <!-- <input type="text" class="form-control" id="charname" v-model="inputData.name"> -->
              <select
                placeholder="Character Selector"
                id="charname"
                class="custom-select"
                v-model="inputData.selectedModel"
                @change="changeSelectedModel($event)"
              >
                <!-- <option>Model Selector</option> -->
                <option
                  v-for="(model, key) in propModels"
                  :key="key"
                  :value="key"
                >
                  {{ model.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="start_time" class="col-sm-4 col-form-label">
              Start Time <i class="fas fa-times text-danger ml-2"></i>
            </label>
            <div class="col-sm-8">
              <input
                type="number"
                class="form-control"
                id="start_time"
                v-model="inputData.startTime"
              />
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="end_time" class="col-sm-4 col-form-label">
              End Time <i class="fas fa-times text-danger ml-2"></i>
            </label>
            <div class="col-sm-8">
              <input
                type="number"
                class="form-control"
                id="end_time"
                v-model="inputData.endTime"
              />
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="presentation_duration" class="col-sm-5 col-form-label">
              Presence Duration (sec)
            </label>
            <div class="col-sm-7">
              <input
                type="text"
                readonly
                :style="
                  this.errorPresenceDuration && {
                    boxShadow: '0 0 0 0.2rem red'
                  }
                "
                class="form-control"
                id="presentation_duration"
                v-model="inputData.presenceDuration"
              />
            </div>
          </div>
          <!-- <div class="row form-group align-items-center">
            <label for="baked_lighting" class="col-sm-4 col-form-label">
              Baked Lighting
            </label>
            <div class="col-sm-8">
              <input type="text" class="form-control" id="baked_lighting" v-model="inputData.bakedLighting">
            </div>
          </div> -->
          <div class="row form-group align-items-center">
            <label for="polygon_count" class="col-sm-4 col-form-label">
              Polygon Count
            </label>
            <div class="col-sm-8">
              <input
                readonly
                type="text"
                class="form-control"
                id="polygon_count"
                v-model="inputData.polygonCount"
              />
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label class="col-sm-4 col-form-label">
              Position of Origin
            </label>
            <div class="col-sm-8">
              <div class="d-flex align-items-center">
                <span class="p-2">x</span>
                <input
                  type="number"
                  class="form-control border-danger"
                  id="position_of_the_origin_x"
                  step="0.01"
                  v-model="inputData.positionOfOrigin.x"
                />
                <span class="p-2">y</span>
                <input
                  type="number"
                  class="form-control border-success"
                  id="position_of_the_origin_y"
                  step="0.01"
                  v-model="inputData.positionOfOrigin.y"
                />
                <span class="p-2">z</span>
                <input
                  type="number"
                  class="form-control border-secondary border-2"
                  id="position_of_the_origin_z"
                  step="0.01"
                  v-model="inputData.positionOfOrigin.z"
                />
              </div>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label class="col-sm-4 col-form-label">
              Rotation of Origin
            </label>
            <div class="col-sm-8">
              <div class="d-flex align-items-center">
                <span class="p-2">x</span>
                <input
                  type="number"
                  class="form-control"
                  id="rotation_of_the_origin_x"
                  step="0.01"
                  v-model="inputData.rotationOfOrigin.x"
                />
                <span class="p-2">y</span>
                <input
                  type="number"
                  class="form-control"
                  id="rotation_of_the_origin_y"
                  step="0.01"
                  v-model="inputData.rotationOfOrigin.y"
                />
                <span class="p-2">z</span>
                <input
                  type="number"
                  class="form-control"
                  id="rotation_of_the_origin_z"
                  step="0.01"
                  v-model="inputData.rotationOfOrigin.z"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="fields-wrapper">
          <div class="row form-group align-items-center">
            <label class="col-sm-6 col-form-label">
              Scale (in meters)
            </label>
            <div class="col-sm-6">
              <div class="row align-items-center">
                <div class="col-8">
                  <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    v-model="inputData.scale"
                  />
                  <input
                    type="number"
                    class="form-control"
                    step="0.01"
                    max="1"
                    min="0"
                    v-model="inputData.scale"
                  />
                </div>
                <span class="col-4">{{ inputData.scale }}</span>
              </div>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label class="col-sm-6 col-form-label">
              Dimensions (meters)
            </label>
            <div class="col-sm-6">
              <div class="d-flex align-items-center">
                <span class="p-2">x</span>
                <input
                  readonly
                  type="text"
                  class="form-control"
                  id="dimensions_x"
                  v-model="inputData.dimensions.x"
                />
                <span class="p-2">y</span>
                <input
                  readonly
                  type="text"
                  class="form-control"
                  id="dimensions_y"
                  v-model="inputData.dimensions.y"
                />
                <span class="p-2">z</span>
                <input
                  readonly
                  type="text"
                  class="form-control"
                  id="dimensions_z"
                  v-model="inputData.dimensions.z"
                />
              </div>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="rig" class="col-sm-6 col-form-label">
              Rig Type
            </label>
            <div class="col-sm-6">
              <select
                id="rig"
                class="custom-select"
                v-model="inputData.rigType"
              >
                <option value="Humanoid">Humanoid</option>
                <option value="Custom">Custom</option>
              </select>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="materials" class="col-sm-6 col-form-label">
              Materials <i class="fas fa-times text-danger ml-2"></i>
            </label>
            <div class="col-sm-6">
              <select
                id="materials"
                class="custom-select"
                v-model="inputData.material"
              >
                <option>Select Material</option>
                <option>Link 1</option>
                <option>Link 2</option>
                <option>Link 3</option>
              </select>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="interactive_surfaces" class="col-sm-6 col-form-label">
              Interactive Surfaces <i class="fas fa-times text-danger ml-2"></i>
            </label>
            <div class="col-sm-6">
              <select
                id="interactive_surfaces"
                class="custom-select"
                v-model="inputData.interactiveSurface"
              >
                <option>Select Interactive Surfaces</option>
                <option>Link 1</option>
                <option>Link 2</option>
                <option>Link 3</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {},
  props: ['selectedCharecter', 'charData', 'currentIndex'],
  data () {
    return {
      mainCharacterIndex: 0,
      errorPresenceDuration: false,
      releaseLock: true,
      isLoaded: false,
      activeCharacter: {},
      inputData: {
        objectId: '',
        elementType: 'Object3D',
        name: '',
        image: '',
        startTime: 0,
        endTime: 10,
        presenceDuration: '',
        bakedLighting: '',
        polygonCount: '',
        selectedModel: null,
        positionOfOrigin: {
          x: 0.0,
          y: 0.0,
          z: 0.0
        },
        rotationOfOrigin: {
          x: 0.0,
          y: 0.0,
          z: 0.0
        },
        scale: 1.0,
        dimensions: {
          x: 0.0,
          y: 0.0,
          z: 0.0
        },
        rigType: '',
        material: '',
        interactiveSurface: '',
        origin: {
          position: {
            x: 0.0,
            y: 0.0,
            z: 0.0
          },
          rotation: {
            x: 0.0,
            y: 0.0,
            z: 0.0
          }
        }
      },
      saveData: {
        object3D: {
          name: '',
          objectId: '',
          startTime: '',
          endTime: '',
          presenceDuration: '',
          bakedLighting: '',
          polygonCount: '',
          scale: 0,
          dimensions: [],
          rigType: '',
          material: '',
          interactiveSurface: '',
          origin: {
            position: [],
            rotation: []
          },
          object3DElements: []
        }
      }
    }
  },
  created () {
    this.listPropModels()
  },

  methods: {
    saveToDB () {
      this.saveData.elementType = this.inputData.elementType
      this.saveData.object3D.name = this.inputData.name
      this.saveData.object3D.startTime = this.inputData.startTime
      this.saveData.object3D.endTime = this.inputData.endTime
      this.saveData.object3D.presenceDuration = this.inputData.presenceDuration
      this.saveData.object3D.bakedLighting = this.inputData.bakedLighting
      this.saveData.object3D.polygonCount = this.inputData.polygonCount
      this.saveData.object3D.origin.position[0] = this.inputData.positionOfOrigin.x || 0.0
      this.saveData.object3D.origin.position[1] = this.inputData.positionOfOrigin.y || 0.0
      this.saveData.object3D.origin.position[2] = this.inputData.positionOfOrigin.z || 0.0
      this.saveData.object3D.origin.rotation[0] = this.inputData.rotationOfOrigin.x || 0.0
      this.saveData.object3D.origin.rotation[1] = this.inputData.rotationOfOrigin.y || 0.0
      this.saveData.object3D.origin.rotation[2] = this.inputData.rotationOfOrigin.z || 0.0
      this.saveData.object3D.scale = this.inputData.scale
      this.saveData.object3D.dimensions[0] = this.inputData.dimensions.x
        ? this.inputData.dimensions.x
        : 0
      this.saveData.object3D.dimensions[1] = this.inputData.dimensions.y
        ? this.inputData.dimensions.y
        : 0
      this.saveData.object3D.dimensions[2] = this.inputData.dimensions.z
        ? this.inputData.dimensions.z
        : 0
      this.saveData.object3D.rigType = this.inputData.rigType
      this.saveData.object3D.material = this.inputData.material
      this.saveData.object3D.interactiveSurface = this.inputData.interactiveSurface
      this.saveData.object3D.type = 'object3D'
      this.saveData.object3D.objectId = this.inputData.objectId
      this.saveData.object3D.layer = 1
      this.saveData.successCallback = this.showSuccessToast
      this.saveData.errorCallback = this.showErrorToast

      for (const [key, value] of Object.entries(this.propModels)) {
        if (value.name === this.inputData.name) {
          this.saveData.object3D.objectDbHash = key
          this.saveData.object3D.AndroidAssetBundle =
            value.asset_bundle.Android.fileURL
          this.saveData.object3D.iOSAssetBundle = value.asset_bundle.iOS.fileURL
          this.saveData.object3D.webglAssetBundle = value.asset_bundle.WebGL.fileURL
          break
        }
      }
      this.$store.dispatch('saveInspector', this.saveData)
      this.releaseLock = true
    },
    showSuccessToast () {
      this.$toast('Main inspector data saved', {
        timeout: 3000,
        type: 'success',
        showCloseButtonOnHover: true
      })
    },
    showErrorToast () {
      this.$toast('Main inspector data failed', {
        timeout: 3000,
        type: 'error',
        showCloseButtonOnHover: true
      })
    },
    ...mapActions(['listPropModels']),
    changeSelectedModel () {
      if (event) {
        let newCharacters = this.characters
        newCharacters = this.characters.map(char =>
          char.objectId === this.activeCharacter.objectId
            ? {
              ...char,
              objectDbHash: event.target.value,
              name: this.propModels[event.target.value].name,
              scale: this.propModels[event.target.value].scale || 1,
              AndroidAssetBundle: this.propModels[event.target.value]
                  .asset_bundle.Android.fileURL,
              iOSAssetBundle: this.propModels[event.target.value].asset_bundle
                  .iOS.fileURL,
              webglAssetBundle: this.propModels[event.target.value].asset_bundle
                  .WebGL.fileURL,
              material: this.propModels[event.target.value].material,
              dimentions: [
                this.propModels[event.target.value].dimension.X || 0.0,
                this.propModels[event.target.value].dimension.Y || 0.0,
                this.propModels[event.target.value].dimension.Z || 0.0
              ]
            }
            : { ...char }
        )
        this.$store.dispatch('updateCharacters', [])
        console.log(newCharacters)
        this.$store.dispatch('updateCharacters', newCharacters)
      }
    },
    getActiveChar () {
      let found = false
      for (let i = 0; i < this.characters.length; i++) {
        const char = this.characters[i]
        if (char.active) {
          this.activeCharacter = char
          found = true
        }
      }
      if (!found) {
        this.activeCharacter = this.characters[0]
      }
      // Checking if the field is diffent of the one in the activeCharacter
      // then affecting to it, otherwise there will be an infinite loop because of the inputData watcher
      if (this.activeCharacter) {
        this.inputData.objectId = this.activeCharacter.objectId
        this.inputData.name !== this.activeCharacter.name &&
          (this.inputData.name = this.activeCharacter.name)
        this.inputData.image !==
          (this.propModels &&
            this.activeCharacter.objectDbHash &&
            this.propModels[this.activeCharacter.objectDbHash] &&
            this.propModels[this.activeCharacter.objectDbHash].image.imageURL &&
            (this.inputData.image =
              this.propModels &&
              this.activeCharacter.objectDbHash &&
              this.propModels[this.activeCharacter.objectDbHash] &&
              this.propModels[this.activeCharacter.objectDbHash].image
                .imageURL))
        this.inputData.startTime !== this.activeCharacter.startTime &&
          (this.inputData.startTime = this.activeCharacter.startTime)
        this.inputData.selectedModel !== this.activeCharacter.objectDbHash &&
          (this.inputData.selectedModel = this.activeCharacter.objectDbHash)
        this.inputData.endTime !== this.activeCharacter.endTime &&
          (this.inputData.endTime = this.activeCharacter.endTime)
        this.inputData.bakedLighting !== this.activeCharacter.bakedLighting &&
          (this.inputData.bakedLighting = this.activeCharacter.bakedLighting)
        this.inputData.polygonCount !== this.activeCharacter.polygonCount &&
          (this.inputData.polygonCount = this.activeCharacter.polygonCount)
        this.inputData.positionOfOrigin.x !==
          this.activeCharacter.origin.position[0] &&
          (this.inputData.positionOfOrigin.x = this.activeCharacter.origin.position[0])
        this.inputData.positionOfOrigin.y !==
          this.activeCharacter.origin.position[1] &&
          (this.inputData.positionOfOrigin.y = this.activeCharacter.origin.position[1])
        this.inputData.positionOfOrigin.z !==
          this.activeCharacter.origin.position[2] &&
          (this.inputData.positionOfOrigin.z = this.activeCharacter.origin.position[2])
        this.inputData.rotationOfOrigin.x !==
          this.activeCharacter.origin.rotation[0] &&
          (this.inputData.rotationOfOrigin.x = this.activeCharacter.origin.rotation[0])
        this.inputData.rotationOfOrigin.y !==
          this.activeCharacter.origin.rotation[1] &&
          (this.inputData.rotationOfOrigin.y = this.activeCharacter.origin.rotation[1])
        this.inputData.rotationOfOrigin.z !==
          this.activeCharacter.origin.rotation[2] &&
          (this.inputData.rotationOfOrigin.z = this.activeCharacter.origin.rotation[2])
        this.inputData.scale !== this.activeCharacter.scale &&
          (this.inputData.scale = this.activeCharacter.scale)
        this.inputData.rigType !== this.activeCharacter.rigType &&
          (this.inputData.rigType = this.activeCharacter.rigType)
        this.inputData.material !== this.activeCharacter.material &&
          (this.inputData.material = this.activeCharacter.material)
        this.inputData.interactiveSurface !==
          this.activeCharacter.interactiveSurface &&
          (this.inputData.interactiveSurface = this.activeCharacter.interactiveSurface)

        this.isLoaded = true
      }
    },
    dispatchActiveChar (data) {
      let newCharacters = this.characters
      newCharacters = this.characters.map(char =>
        char.objectId === this.activeCharacter.objectId
          ? {
            ...char,
            startTime: data.startTime,
            endTime: data.endTime,
            presenceDuration: data.presenceDuration,
            scale: data.scale,
            rigType: data.rigType,
            material: data.material,
            origin: {
              position: [
                data.positionOfOrigin.x,
                data.positionOfOrigin.y,
                data.positionOfOrigin.z
              ],
              rotation: [
                data.rotationOfOrigin.x,
                data.rotationOfOrigin.y,
                data.rotationOfOrigin.z
              ]
            },
            interactiveSurface: data.interactiveSurface
          }
          : { ...char }
      )
      if (this.characters != newCharacters) {
        this.$store.dispatch('updateCharacters', [])
        this.$store.dispatch('updateCharacters', newCharacters)
      }
    }
  },
  mounted () {
    setTimeout(() => {
      // this.saveToDB()
    }, 2000)
    var newChars = []
    var val = this.characters
    for (let i = 0; i < val.length; i++) {
      const char = val[i]
      if (char.active) {
        this.activeCharacter = char
      }
    }
    this.getActiveChar()
  },
  watch: {
    characters (val) {
      this.isLoaded = false
      this.getActiveChar()
    },
    inputData: {
      handler: function (val, oldVal) {
        this.dispatchActiveChar(val)
        this.inputData.presenceDuration =
          parseInt(this.inputData.endTime) - parseInt(this.inputData.startTime)
        this.errorPresenceDuration = !!(
          parseInt(this.inputData.endTime) <= parseInt(this.inputData.startTime)
        )
        if (this.releaseLock && this.isLoaded) {
          this.releaseLock = false
          setTimeout(() => {
            // this.saveToDB()
          }, 3000)
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['characters', 'fbxModels', 'inspector', 'propModels']),
    ...mapGetters(['getStartTime', 'getEndTime', 'getCharacters']),
    name: {
      get: function () {
        return this.$store.state.inspector.main.name
      },
      set: function (newVal) {
        this.inputData = this.$store.state.inspector.main
        this.inputData.name = newVal
        this.$store.dispatch('saveInspector', this.inputData)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.border-2 {
    border-width:2px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-components/models/maininspector.vue